import { BaseAction } from "../base/base.action";

export class ProfileAction extends BaseAction {
    constructor() {
        super("PROFILE")
    }
}


